<template>
    <div class="root flex flex-col border border-radius-ms scroll padding-l">
        <div v-for="item in dirData" ref="mytree"  >
              <my-tree  key:="key" :data="item" :root="root"></my-tree>
        </div>
    </div>
</template>

<script>
    import MyTree from '@/components/tree/Tree' //引入我们写好的递归组件

    export default{
        name:'TreeView',
        props: {
            dirData: {} 
        },
        components:{
            MyTree
        },
        data() {
            return {
                root:this
            }
        },
        methods:{
            clearSelect(node) {
                console.log("node", node);
                node.select = false;
                if (node.$children && node.$children.length >0) {
                    console.log("child", node.$children)
                    let children = node.$children;
                    children.forEach((i) => {
                        i.select = false;
                        this.clearSelect(i);
                    }) 
                }
            },
            selectItemClick(id,name){
                this.clearSelect(this);
                this.$emit("change", id, name);
            },
        }
     }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/tree/TreeView.vue